import { render, staticRenderFns } from "./FormCreateResearchPage3.vue?vue&type=template&id=c63642f2&scoped=true&"
import script from "./FormCreateResearchPage3.vue?vue&type=script&lang=js&"
export * from "./FormCreateResearchPage3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c63642f2",
  null
  
)

export default component.exports